//cspell:ignore mensaje
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, PhonePreview, PhonePreviewWhatsApp, Spinner, Text } from '@/lib/v2/components';
import PhonePreviewWhatsAppV0 from '@/lib/v2/components/PhonePreviewWhatsApp/PhonePreviewWhatsAppV0';

import { useFeatureFlag } from '@/src/application/hooks/util/useFeatureFlag';
import { useContentVariables } from '@/src/modules/CampaignsModule/components/actionManagement/WhatsAppAction/hooks/useContentVariables';

import { atomCurrentActionId } from '@/modules/CampaignsModule/atoms/actionsAtom';
import { atomActionInfoSms } from '@/modules/CampaignsModule/atoms/actionSMSAtom';
import { atomCurrentWhatsAppTemplate } from '@/modules/CampaignsModule/atoms/actionWhatsAppAtom';
import { useExtractBodyFromJson } from '@/modules/CampaignsModule/components/actionManagement/WhatsAppAction/hooks/useExtractBodyFromJson';
import { useWhatsAppTemplate } from '@/modules/CampaignsModule/components/CampaignsModal/PhonePreviewModal/hooks/useWhatsAppTemplate';
import { useActionSmsData } from '@/modules/CampaignsModule/hooks/useActionSmsData';

const PhonePreviewModal = () => {
  const { t } = useTranslation();
  const isTemplateV0Enabled = useFeatureFlag('enableWhatsAppTemplateV0');

  const actionInfoSms = useAtomValue(atomActionInfoSms);
  const [currentActionId, setCurrentActionId] = useAtom(atomCurrentActionId);
  const setCurrentWhatsAppTemplate = useSetAtom(atomCurrentWhatsAppTemplate);

  const { getSmsInfo, loading } = useActionSmsData(Number(currentActionId));
  const bodyMessage = useExtractBodyFromJson(actionInfoSms?.mensaje ?? '');

  const { parseAndReplaceContentVariables } = useContentVariables();
  const { convertToWhatsAppTemplate, getMediaUrl } = useWhatsAppTemplate();

  useEffect(() => {
    void getSmsInfo();
  }, [getSmsInfo]);

  const closeModal = useCallback(() => {
    setCurrentActionId(undefined);
  }, [setCurrentActionId]);

  //cspell:disable
  const renderContent = () => {
    if (loading) {
      return <Spinner withoutOverlay />;
    }

    if (typeof actionInfoSms?.mensaje === 'string' && actionInfoSms.mensaje.trim() !== '') {
      const result = parseAndReplaceContentVariables(actionInfoSms.mensaje);

      if (result.isValid && result.contentSid) {
        const { template, canUseTemplateV0 } = convertToWhatsAppTemplate(result);

        if (isTemplateV0Enabled && canUseTemplateV0 && template) {
          setCurrentWhatsAppTemplate(template);
          return <PhonePreviewWhatsAppV0 isShortPhone />;
        }

        const mediaUrl = getMediaUrl(result);
        return <PhonePreviewWhatsApp shortPhone mediaUrl={mediaUrl} message={result.body} />;
      }
      return <PhonePreview shortPhone message={bodyMessage} />;
    }

    return (
      <div className="flex h-300 w-430 items-center justify-center p-12">
        <span className="block py-2 text-center text-16 text-emblue-disabled">
          {t('CAMPAIGN_ACTIONS_MAIN.SMS_ACTION.noMessage')}
        </span>
      </div>
    );
  };
  //cspell:enable

  return (
    <Modal open={!!currentActionId} onClose={closeModal}>
      <div className="flex flex-col gap-2 divide-y">
        <header>
          <Text as="h3" fontWeight="medium" variant="sub-headline">
            {t('CAMPAIGN_ACTIONS_MAIN.SMS_ACTION.preview')}
          </Text>
        </header>
        <section className="flex w-full justify-center pt-6 text-16">{renderContent()}</section>
      </div>
    </Modal>
  );
};

export default PhonePreviewModal;
